import React from 'react';
import PropTypes from 'prop-types';
import { LuCheck, LuLock } from 'react-icons/lu';
import { HelpNote } from '../components/ProfileUi';

/**
 * "Okudum ve anladım" kutusu, belge görüntüleyicilerin sonunda. Belge yüklenene
 * kadar kilitli durur; okunmuşken tekrar dokunmak onayı geri alır.
 */
const ReadConfirmation = ({ isRead, unlocked, onToggle, confirmLabel, lockedHint, pendingHint, readHint }) => (
  <div className={`tw-space-y-2.5 tw-rounded-2xl tw-border tw-p-3.5 sm:tw-p-4 ${
    isRead
      ? 'tw-border-emerald-500/30 tw-bg-emerald-500/[0.07]'
      : 'tw-border-slate-200 tw-bg-slate-50/80 dark:tw-border-white/10 dark:tw-bg-white/[0.03]'
  }`}
  >
    <button
      type="button"
      role="checkbox"
      aria-checked={isRead}
      disabled={!unlocked}
      onClick={onToggle}
      className="tw-flex tw-w-full tw-items-center tw-gap-3 tw-rounded-xl tw-bg-transparent tw-text-left focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-teal-500/50 disabled:tw-cursor-not-allowed"
    >
      <span
        aria-hidden="true"
        className={`tw-grid tw-h-6 tw-w-6 tw-shrink-0 tw-place-items-center tw-rounded-lg tw-border-2 tw-transition-colors ${
          isRead
            ? 'tw-border-emerald-500 tw-bg-emerald-500 tw-text-white'
            : unlocked
              ? 'tw-border-teal-500 tw-bg-white dark:tw-bg-transparent'
              : 'tw-border-slate-300 tw-bg-slate-100 tw-text-slate-400 dark:tw-border-white/15 dark:tw-bg-white/[0.04]'
        }`}
      >
        {isRead && <LuCheck className="tw-h-4 tw-w-4" strokeWidth={3} />}
        {!isRead && !unlocked && <LuLock className="tw-h-3 tw-w-3" />}
      </span>
      <span className={`tw-text-sm tw-font-semibold ${unlocked ? 'tw-text-slate-800 dark:tw-text-slate-100' : 'tw-text-slate-400 dark:tw-text-slate-500'}`}>
        {confirmLabel}
      </span>
    </button>
    {!isRead && !unlocked && <HelpNote tone="warning">{lockedHint}</HelpNote>}
    {!isRead && unlocked && pendingHint && <p className="tw-text-xs tw-text-slate-500 dark:tw-text-slate-400">{pendingHint}</p>}
    {isRead && <p className="tw-text-xs tw-text-emerald-700 dark:tw-text-emerald-300">{readHint}</p>}
  </div>
);

ReadConfirmation.propTypes = {
  isRead: PropTypes.bool,
  unlocked: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  lockedHint: PropTypes.string.isRequired,
  pendingHint: PropTypes.string,
  readHint: PropTypes.string.isRequired,
};

export default ReadConfirmation;
